import * as React from "react";
import { Route } from "react-router-dom";
import type { RouteComponentProps } from "react-router-dom";

import "./styles/index.scss";

import HomeView from "./home/HomeView";
import LinesView from "./plan/LinesView";
import StocksView from "./stocks/StocksView";
import PeopleView from "./people/PeopleView";
import ToolsView from "./tools/ToolsView";

type RoutePermissions = {
    home: boolean;
    lines: boolean;
    stocks: boolean;
    people: boolean;
    tools: boolean;
};

type GetRoutesContext = {
    plant_uuid: string;
    line_group_uuid: string;
    routePermissions: RoutePermissions;
    redirectToFirstRoute: (permissions: RoutePermissions) => React.ReactNode;
};

const getRoutes = (
    { plant_uuid, line_group_uuid, routePermissions, redirectToFirstRoute }: GetRoutesContext,
    { match: { url } }: { match: { url: string } }
) => (
    <>
        <Route
            path={`${url}/home/:selected_view?/:view_params?`}
            exact={true}
            render={(props: RouteComponentProps) => {
                if (routePermissions.home === false) {
                    return redirectToFirstRoute(routePermissions);
                }
                return <HomeView {...props} plant_uuid={plant_uuid} line_group_uuid={line_group_uuid} />;
            }}
        />
        <Route
            path={`${url}/lines/:selected_view?/:view_params?`}
            exact={true}
            render={(props: RouteComponentProps) => {
                if (routePermissions.lines === false) {
                    return redirectToFirstRoute(routePermissions);
                }
                return <LinesView {...props} plant_uuid={plant_uuid} line_group_uuid={line_group_uuid} />;
            }}
        />
        <Route
            path={`${url}/stocks/:selected_view?`}
            exact={true}
            render={(props: RouteComponentProps) => {
                if (routePermissions.stocks === false) {
                    return redirectToFirstRoute(routePermissions);
                }
                return <StocksView {...props} plant_uuid={plant_uuid} line_group_uuid={line_group_uuid} />;
            }}
        />
        <Route
            path={`${url}/people/:selected_view?/:view_params?`}
            exact={true}
            render={(props: RouteComponentProps) => {
                if (routePermissions.people === false) {
                    return redirectToFirstRoute(routePermissions);
                }
                return <PeopleView {...props} plant_uuid={plant_uuid} line_group_uuid={line_group_uuid} />;
            }}
        />
        <Route
            path={`${url}/tools/:selected_view?`}
            exact={true}
            render={(props: RouteComponentProps) => {
                if (routePermissions.tools === false) {
                    return redirectToFirstRoute(routePermissions);
                }
                return <ToolsView {...props} plant_uuid={plant_uuid} line_group_uuid={line_group_uuid} />;
            }}
        />
    </>
);

export const createRoutes = (context: GetRoutesContext) => {
    return (routeProps: { match: { url: string } }) => getRoutes(context, routeProps);
};
